export function submissionsProcessingText(value) {
  if (typeof value === 'number' && value > 0) return String(value);
  return 'Not currently tracked';
}

export function hasTelemetryForPeriod(summary, eventsTotal = 0, operations = [], concurrency = null) {
  const totals = summary?.totals || {};
  const hubspot = summary?.hubspot || {};
  const live = summary?.live || {};
  return Boolean(
    totals.sessionStarts
    || totals.openOperations
    || totals.submitAttempts
    || hubspot.totalRequests
    || live.activeSessionsNow
    || eventsTotal
    || (operations || []).length
    || (concurrency?.series || []).length
  );
}

export function timezoneSummary() {
  return {
    storage: 'UTC',
    grouping: 'UTC',
    display: 'browser local time for timestamps; UTC labels for grouped buckets',
  };
}